/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root"
import { Route as PrivateImport } from "./routes/_private"
import { Route as IndexImport } from "./routes/index"
import { Route as InvitationsAcceptImport } from "./routes/invitations.accept"
import { Route as AuthSetPasswordImport } from "./routes/auth/set-password"
import { Route as AuthResetPasswordRequestImport } from "./routes/auth/reset-password-request"
import { Route as AuthResetPasswordConfirmImport } from "./routes/auth/reset-password-confirm"
import { Route as AuthResetPasswordImport } from "./routes/auth/reset-password"
import { Route as AuthLoginImport } from "./routes/auth/login"
import { Route as AuthConfirmSignupImport } from "./routes/auth/confirm-signup"
import { Route as PrivateTripsImport } from "./routes/_private/trips"
import { Route as PrivateSpeciesImport } from "./routes/_private/species"
import { Route as PrivateSettingsImport } from "./routes/_private/settings"
import { Route as PrivatePeopleImport } from "./routes/_private/people"
import { Route as PrivateNoAccessImport } from "./routes/_private/no-access"
import { Route as PrivateInvitationsImport } from "./routes/_private/invitations"
import { Route as PrivateInventoryImport } from "./routes/_private/inventory"
import { Route as PrivateTripsIndexImport } from "./routes/_private/trips/index"
import { Route as PrivateSpeciesIndexImport } from "./routes/_private/species/index"
import { Route as PrivateSettingsIndexImport } from "./routes/_private/settings/index"
import { Route as PrivatePeopleIndexImport } from "./routes/_private/people/index"
import { Route as PrivateInvitationsIndexImport } from "./routes/_private/invitations/index"
import { Route as PrivateInventoryIndexImport } from "./routes/_private/inventory/index"
import { Route as PrivateSettingsTestingOrgsImport } from "./routes/_private/settings/testing-orgs"
import { Route as PrivateSettingsStorageLocationsImport } from "./routes/_private/settings/storage-locations"
import { Route as PrivateSettingsOrganisationDetailsImport } from "./routes/_private/settings/organisation-details"
import { Route as PrivateSettingsContainersImport } from "./routes/_private/settings/containers"
import { Route as PrivateInvitationsNewImport } from "./routes/_private/invitations/new"
import { Route as PrivateInventorySendForTestingImport } from "./routes/_private/inventory/send-for-testing"
import { Route as PrivateTripsIdIndexImport } from "./routes/_private/trips/$id/index"
import { Route as PrivateSpeciesIdIndexImport } from "./routes/_private/species/$id/index"
import { Route as PrivateTripsIdEditImport } from "./routes/_private/trips/$id/edit"

// Create/Update Routes

const PrivateRoute = PrivateImport.update({
  id: "/_private",
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any)

const InvitationsAcceptRoute = InvitationsAcceptImport.update({
  id: "/invitations/accept",
  path: "/invitations/accept",
  getParentRoute: () => rootRoute,
} as any)

const AuthSetPasswordRoute = AuthSetPasswordImport.update({
  id: "/auth/set-password",
  path: "/auth/set-password",
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRequestRoute = AuthResetPasswordRequestImport.update({
  id: "/auth/reset-password-request",
  path: "/auth/reset-password-request",
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordConfirmRoute = AuthResetPasswordConfirmImport.update({
  id: "/auth/reset-password-confirm",
  path: "/auth/reset-password-confirm",
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: "/auth/reset-password",
  path: "/auth/reset-password",
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: "/auth/login",
  path: "/auth/login",
  getParentRoute: () => rootRoute,
} as any)

const AuthConfirmSignupRoute = AuthConfirmSignupImport.update({
  id: "/auth/confirm-signup",
  path: "/auth/confirm-signup",
  getParentRoute: () => rootRoute,
} as any)

const PrivateTripsRoute = PrivateTripsImport.update({
  id: "/trips",
  path: "/trips",
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateSpeciesRoute = PrivateSpeciesImport.update({
  id: "/species",
  path: "/species",
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateSettingsRoute = PrivateSettingsImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => PrivateRoute,
} as any)

const PrivatePeopleRoute = PrivatePeopleImport.update({
  id: "/people",
  path: "/people",
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateNoAccessRoute = PrivateNoAccessImport.update({
  id: "/no-access",
  path: "/no-access",
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateInvitationsRoute = PrivateInvitationsImport.update({
  id: "/invitations",
  path: "/invitations",
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateInventoryRoute = PrivateInventoryImport.update({
  id: "/inventory",
  path: "/inventory",
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateTripsIndexRoute = PrivateTripsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrivateTripsRoute,
} as any)

const PrivateSpeciesIndexRoute = PrivateSpeciesIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrivateSpeciesRoute,
} as any)

const PrivateSettingsIndexRoute = PrivateSettingsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrivateSettingsRoute,
} as any)

const PrivatePeopleIndexRoute = PrivatePeopleIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrivatePeopleRoute,
} as any)

const PrivateInvitationsIndexRoute = PrivateInvitationsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrivateInvitationsRoute,
} as any)

const PrivateInventoryIndexRoute = PrivateInventoryIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrivateInventoryRoute,
} as any)

const PrivateSettingsTestingOrgsRoute = PrivateSettingsTestingOrgsImport.update(
  {
    id: "/testing-orgs",
    path: "/testing-orgs",
    getParentRoute: () => PrivateSettingsRoute,
  } as any,
)

const PrivateSettingsStorageLocationsRoute =
  PrivateSettingsStorageLocationsImport.update({
    id: "/storage-locations",
    path: "/storage-locations",
    getParentRoute: () => PrivateSettingsRoute,
  } as any)

const PrivateSettingsOrganisationDetailsRoute =
  PrivateSettingsOrganisationDetailsImport.update({
    id: "/organisation-details",
    path: "/organisation-details",
    getParentRoute: () => PrivateSettingsRoute,
  } as any)

const PrivateSettingsContainersRoute = PrivateSettingsContainersImport.update({
  id: "/containers",
  path: "/containers",
  getParentRoute: () => PrivateSettingsRoute,
} as any)

const PrivateInvitationsNewRoute = PrivateInvitationsNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => PrivateInvitationsRoute,
} as any)

const PrivateInventorySendForTestingRoute =
  PrivateInventorySendForTestingImport.update({
    id: "/send-for-testing",
    path: "/send-for-testing",
    getParentRoute: () => PrivateInventoryRoute,
  } as any)

const PrivateTripsIdIndexRoute = PrivateTripsIdIndexImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => PrivateTripsRoute,
} as any)

const PrivateSpeciesIdIndexRoute = PrivateSpeciesIdIndexImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => PrivateSpeciesRoute,
} as any)

const PrivateTripsIdEditRoute = PrivateTripsIdEditImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => PrivateTripsRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    "/_private": {
      id: "/_private"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof PrivateImport
      parentRoute: typeof rootRoute
    }
    "/_private/inventory": {
      id: "/_private/inventory"
      path: "/inventory"
      fullPath: "/inventory"
      preLoaderRoute: typeof PrivateInventoryImport
      parentRoute: typeof PrivateImport
    }
    "/_private/invitations": {
      id: "/_private/invitations"
      path: "/invitations"
      fullPath: "/invitations"
      preLoaderRoute: typeof PrivateInvitationsImport
      parentRoute: typeof PrivateImport
    }
    "/_private/no-access": {
      id: "/_private/no-access"
      path: "/no-access"
      fullPath: "/no-access"
      preLoaderRoute: typeof PrivateNoAccessImport
      parentRoute: typeof PrivateImport
    }
    "/_private/people": {
      id: "/_private/people"
      path: "/people"
      fullPath: "/people"
      preLoaderRoute: typeof PrivatePeopleImport
      parentRoute: typeof PrivateImport
    }
    "/_private/settings": {
      id: "/_private/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof PrivateSettingsImport
      parentRoute: typeof PrivateImport
    }
    "/_private/species": {
      id: "/_private/species"
      path: "/species"
      fullPath: "/species"
      preLoaderRoute: typeof PrivateSpeciesImport
      parentRoute: typeof PrivateImport
    }
    "/_private/trips": {
      id: "/_private/trips"
      path: "/trips"
      fullPath: "/trips"
      preLoaderRoute: typeof PrivateTripsImport
      parentRoute: typeof PrivateImport
    }
    "/auth/confirm-signup": {
      id: "/auth/confirm-signup"
      path: "/auth/confirm-signup"
      fullPath: "/auth/confirm-signup"
      preLoaderRoute: typeof AuthConfirmSignupImport
      parentRoute: typeof rootRoute
    }
    "/auth/login": {
      id: "/auth/login"
      path: "/auth/login"
      fullPath: "/auth/login"
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    "/auth/reset-password": {
      id: "/auth/reset-password"
      path: "/auth/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    "/auth/reset-password-confirm": {
      id: "/auth/reset-password-confirm"
      path: "/auth/reset-password-confirm"
      fullPath: "/auth/reset-password-confirm"
      preLoaderRoute: typeof AuthResetPasswordConfirmImport
      parentRoute: typeof rootRoute
    }
    "/auth/reset-password-request": {
      id: "/auth/reset-password-request"
      path: "/auth/reset-password-request"
      fullPath: "/auth/reset-password-request"
      preLoaderRoute: typeof AuthResetPasswordRequestImport
      parentRoute: typeof rootRoute
    }
    "/auth/set-password": {
      id: "/auth/set-password"
      path: "/auth/set-password"
      fullPath: "/auth/set-password"
      preLoaderRoute: typeof AuthSetPasswordImport
      parentRoute: typeof rootRoute
    }
    "/invitations/accept": {
      id: "/invitations/accept"
      path: "/invitations/accept"
      fullPath: "/invitations/accept"
      preLoaderRoute: typeof InvitationsAcceptImport
      parentRoute: typeof rootRoute
    }
    "/_private/inventory/send-for-testing": {
      id: "/_private/inventory/send-for-testing"
      path: "/send-for-testing"
      fullPath: "/inventory/send-for-testing"
      preLoaderRoute: typeof PrivateInventorySendForTestingImport
      parentRoute: typeof PrivateInventoryImport
    }
    "/_private/invitations/new": {
      id: "/_private/invitations/new"
      path: "/new"
      fullPath: "/invitations/new"
      preLoaderRoute: typeof PrivateInvitationsNewImport
      parentRoute: typeof PrivateInvitationsImport
    }
    "/_private/settings/containers": {
      id: "/_private/settings/containers"
      path: "/containers"
      fullPath: "/settings/containers"
      preLoaderRoute: typeof PrivateSettingsContainersImport
      parentRoute: typeof PrivateSettingsImport
    }
    "/_private/settings/organisation-details": {
      id: "/_private/settings/organisation-details"
      path: "/organisation-details"
      fullPath: "/settings/organisation-details"
      preLoaderRoute: typeof PrivateSettingsOrganisationDetailsImport
      parentRoute: typeof PrivateSettingsImport
    }
    "/_private/settings/storage-locations": {
      id: "/_private/settings/storage-locations"
      path: "/storage-locations"
      fullPath: "/settings/storage-locations"
      preLoaderRoute: typeof PrivateSettingsStorageLocationsImport
      parentRoute: typeof PrivateSettingsImport
    }
    "/_private/settings/testing-orgs": {
      id: "/_private/settings/testing-orgs"
      path: "/testing-orgs"
      fullPath: "/settings/testing-orgs"
      preLoaderRoute: typeof PrivateSettingsTestingOrgsImport
      parentRoute: typeof PrivateSettingsImport
    }
    "/_private/inventory/": {
      id: "/_private/inventory/"
      path: "/"
      fullPath: "/inventory/"
      preLoaderRoute: typeof PrivateInventoryIndexImport
      parentRoute: typeof PrivateInventoryImport
    }
    "/_private/invitations/": {
      id: "/_private/invitations/"
      path: "/"
      fullPath: "/invitations/"
      preLoaderRoute: typeof PrivateInvitationsIndexImport
      parentRoute: typeof PrivateInvitationsImport
    }
    "/_private/people/": {
      id: "/_private/people/"
      path: "/"
      fullPath: "/people/"
      preLoaderRoute: typeof PrivatePeopleIndexImport
      parentRoute: typeof PrivatePeopleImport
    }
    "/_private/settings/": {
      id: "/_private/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof PrivateSettingsIndexImport
      parentRoute: typeof PrivateSettingsImport
    }
    "/_private/species/": {
      id: "/_private/species/"
      path: "/"
      fullPath: "/species/"
      preLoaderRoute: typeof PrivateSpeciesIndexImport
      parentRoute: typeof PrivateSpeciesImport
    }
    "/_private/trips/": {
      id: "/_private/trips/"
      path: "/"
      fullPath: "/trips/"
      preLoaderRoute: typeof PrivateTripsIndexImport
      parentRoute: typeof PrivateTripsImport
    }
    "/_private/trips/$id/edit": {
      id: "/_private/trips/$id/edit"
      path: "/$id/edit"
      fullPath: "/trips/$id/edit"
      preLoaderRoute: typeof PrivateTripsIdEditImport
      parentRoute: typeof PrivateTripsImport
    }
    "/_private/species/$id/": {
      id: "/_private/species/$id/"
      path: "/$id"
      fullPath: "/species/$id"
      preLoaderRoute: typeof PrivateSpeciesIdIndexImport
      parentRoute: typeof PrivateSpeciesImport
    }
    "/_private/trips/$id/": {
      id: "/_private/trips/$id/"
      path: "/$id"
      fullPath: "/trips/$id"
      preLoaderRoute: typeof PrivateTripsIdIndexImport
      parentRoute: typeof PrivateTripsImport
    }
  }
}

// Create and export the route tree

interface PrivateInventoryRouteChildren {
  PrivateInventorySendForTestingRoute: typeof PrivateInventorySendForTestingRoute
  PrivateInventoryIndexRoute: typeof PrivateInventoryIndexRoute
}

const PrivateInventoryRouteChildren: PrivateInventoryRouteChildren = {
  PrivateInventorySendForTestingRoute: PrivateInventorySendForTestingRoute,
  PrivateInventoryIndexRoute: PrivateInventoryIndexRoute,
}

const PrivateInventoryRouteWithChildren =
  PrivateInventoryRoute._addFileChildren(PrivateInventoryRouteChildren)

interface PrivateInvitationsRouteChildren {
  PrivateInvitationsNewRoute: typeof PrivateInvitationsNewRoute
  PrivateInvitationsIndexRoute: typeof PrivateInvitationsIndexRoute
}

const PrivateInvitationsRouteChildren: PrivateInvitationsRouteChildren = {
  PrivateInvitationsNewRoute: PrivateInvitationsNewRoute,
  PrivateInvitationsIndexRoute: PrivateInvitationsIndexRoute,
}

const PrivateInvitationsRouteWithChildren =
  PrivateInvitationsRoute._addFileChildren(PrivateInvitationsRouteChildren)

interface PrivatePeopleRouteChildren {
  PrivatePeopleIndexRoute: typeof PrivatePeopleIndexRoute
}

const PrivatePeopleRouteChildren: PrivatePeopleRouteChildren = {
  PrivatePeopleIndexRoute: PrivatePeopleIndexRoute,
}

const PrivatePeopleRouteWithChildren = PrivatePeopleRoute._addFileChildren(
  PrivatePeopleRouteChildren,
)

interface PrivateSettingsRouteChildren {
  PrivateSettingsContainersRoute: typeof PrivateSettingsContainersRoute
  PrivateSettingsOrganisationDetailsRoute: typeof PrivateSettingsOrganisationDetailsRoute
  PrivateSettingsStorageLocationsRoute: typeof PrivateSettingsStorageLocationsRoute
  PrivateSettingsTestingOrgsRoute: typeof PrivateSettingsTestingOrgsRoute
  PrivateSettingsIndexRoute: typeof PrivateSettingsIndexRoute
}

const PrivateSettingsRouteChildren: PrivateSettingsRouteChildren = {
  PrivateSettingsContainersRoute: PrivateSettingsContainersRoute,
  PrivateSettingsOrganisationDetailsRoute:
    PrivateSettingsOrganisationDetailsRoute,
  PrivateSettingsStorageLocationsRoute: PrivateSettingsStorageLocationsRoute,
  PrivateSettingsTestingOrgsRoute: PrivateSettingsTestingOrgsRoute,
  PrivateSettingsIndexRoute: PrivateSettingsIndexRoute,
}

const PrivateSettingsRouteWithChildren = PrivateSettingsRoute._addFileChildren(
  PrivateSettingsRouteChildren,
)

interface PrivateSpeciesRouteChildren {
  PrivateSpeciesIndexRoute: typeof PrivateSpeciesIndexRoute
  PrivateSpeciesIdIndexRoute: typeof PrivateSpeciesIdIndexRoute
}

const PrivateSpeciesRouteChildren: PrivateSpeciesRouteChildren = {
  PrivateSpeciesIndexRoute: PrivateSpeciesIndexRoute,
  PrivateSpeciesIdIndexRoute: PrivateSpeciesIdIndexRoute,
}

const PrivateSpeciesRouteWithChildren = PrivateSpeciesRoute._addFileChildren(
  PrivateSpeciesRouteChildren,
)

interface PrivateTripsRouteChildren {
  PrivateTripsIndexRoute: typeof PrivateTripsIndexRoute
  PrivateTripsIdEditRoute: typeof PrivateTripsIdEditRoute
  PrivateTripsIdIndexRoute: typeof PrivateTripsIdIndexRoute
}

const PrivateTripsRouteChildren: PrivateTripsRouteChildren = {
  PrivateTripsIndexRoute: PrivateTripsIndexRoute,
  PrivateTripsIdEditRoute: PrivateTripsIdEditRoute,
  PrivateTripsIdIndexRoute: PrivateTripsIdIndexRoute,
}

const PrivateTripsRouteWithChildren = PrivateTripsRoute._addFileChildren(
  PrivateTripsRouteChildren,
)

interface PrivateRouteChildren {
  PrivateInventoryRoute: typeof PrivateInventoryRouteWithChildren
  PrivateInvitationsRoute: typeof PrivateInvitationsRouteWithChildren
  PrivateNoAccessRoute: typeof PrivateNoAccessRoute
  PrivatePeopleRoute: typeof PrivatePeopleRouteWithChildren
  PrivateSettingsRoute: typeof PrivateSettingsRouteWithChildren
  PrivateSpeciesRoute: typeof PrivateSpeciesRouteWithChildren
  PrivateTripsRoute: typeof PrivateTripsRouteWithChildren
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateInventoryRoute: PrivateInventoryRouteWithChildren,
  PrivateInvitationsRoute: PrivateInvitationsRouteWithChildren,
  PrivateNoAccessRoute: PrivateNoAccessRoute,
  PrivatePeopleRoute: PrivatePeopleRouteWithChildren,
  PrivateSettingsRoute: PrivateSettingsRouteWithChildren,
  PrivateSpeciesRoute: PrivateSpeciesRouteWithChildren,
  PrivateTripsRoute: PrivateTripsRouteWithChildren,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "": typeof PrivateRouteWithChildren
  "/inventory": typeof PrivateInventoryRouteWithChildren
  "/invitations": typeof PrivateInvitationsRouteWithChildren
  "/no-access": typeof PrivateNoAccessRoute
  "/people": typeof PrivatePeopleRouteWithChildren
  "/settings": typeof PrivateSettingsRouteWithChildren
  "/species": typeof PrivateSpeciesRouteWithChildren
  "/trips": typeof PrivateTripsRouteWithChildren
  "/auth/confirm-signup": typeof AuthConfirmSignupRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/reset-password-confirm": typeof AuthResetPasswordConfirmRoute
  "/auth/reset-password-request": typeof AuthResetPasswordRequestRoute
  "/auth/set-password": typeof AuthSetPasswordRoute
  "/invitations/accept": typeof InvitationsAcceptRoute
  "/inventory/send-for-testing": typeof PrivateInventorySendForTestingRoute
  "/invitations/new": typeof PrivateInvitationsNewRoute
  "/settings/containers": typeof PrivateSettingsContainersRoute
  "/settings/organisation-details": typeof PrivateSettingsOrganisationDetailsRoute
  "/settings/storage-locations": typeof PrivateSettingsStorageLocationsRoute
  "/settings/testing-orgs": typeof PrivateSettingsTestingOrgsRoute
  "/inventory/": typeof PrivateInventoryIndexRoute
  "/invitations/": typeof PrivateInvitationsIndexRoute
  "/people/": typeof PrivatePeopleIndexRoute
  "/settings/": typeof PrivateSettingsIndexRoute
  "/species/": typeof PrivateSpeciesIndexRoute
  "/trips/": typeof PrivateTripsIndexRoute
  "/trips/$id/edit": typeof PrivateTripsIdEditRoute
  "/species/$id": typeof PrivateSpeciesIdIndexRoute
  "/trips/$id": typeof PrivateTripsIdIndexRoute
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "": typeof PrivateRouteWithChildren
  "/no-access": typeof PrivateNoAccessRoute
  "/auth/confirm-signup": typeof AuthConfirmSignupRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/reset-password-confirm": typeof AuthResetPasswordConfirmRoute
  "/auth/reset-password-request": typeof AuthResetPasswordRequestRoute
  "/auth/set-password": typeof AuthSetPasswordRoute
  "/invitations/accept": typeof InvitationsAcceptRoute
  "/inventory/send-for-testing": typeof PrivateInventorySendForTestingRoute
  "/invitations/new": typeof PrivateInvitationsNewRoute
  "/settings/containers": typeof PrivateSettingsContainersRoute
  "/settings/organisation-details": typeof PrivateSettingsOrganisationDetailsRoute
  "/settings/storage-locations": typeof PrivateSettingsStorageLocationsRoute
  "/settings/testing-orgs": typeof PrivateSettingsTestingOrgsRoute
  "/inventory": typeof PrivateInventoryIndexRoute
  "/invitations": typeof PrivateInvitationsIndexRoute
  "/people": typeof PrivatePeopleIndexRoute
  "/settings": typeof PrivateSettingsIndexRoute
  "/species": typeof PrivateSpeciesIndexRoute
  "/trips": typeof PrivateTripsIndexRoute
  "/trips/$id/edit": typeof PrivateTripsIdEditRoute
  "/species/$id": typeof PrivateSpeciesIdIndexRoute
  "/trips/$id": typeof PrivateTripsIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/": typeof IndexRoute
  "/_private": typeof PrivateRouteWithChildren
  "/_private/inventory": typeof PrivateInventoryRouteWithChildren
  "/_private/invitations": typeof PrivateInvitationsRouteWithChildren
  "/_private/no-access": typeof PrivateNoAccessRoute
  "/_private/people": typeof PrivatePeopleRouteWithChildren
  "/_private/settings": typeof PrivateSettingsRouteWithChildren
  "/_private/species": typeof PrivateSpeciesRouteWithChildren
  "/_private/trips": typeof PrivateTripsRouteWithChildren
  "/auth/confirm-signup": typeof AuthConfirmSignupRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/reset-password-confirm": typeof AuthResetPasswordConfirmRoute
  "/auth/reset-password-request": typeof AuthResetPasswordRequestRoute
  "/auth/set-password": typeof AuthSetPasswordRoute
  "/invitations/accept": typeof InvitationsAcceptRoute
  "/_private/inventory/send-for-testing": typeof PrivateInventorySendForTestingRoute
  "/_private/invitations/new": typeof PrivateInvitationsNewRoute
  "/_private/settings/containers": typeof PrivateSettingsContainersRoute
  "/_private/settings/organisation-details": typeof PrivateSettingsOrganisationDetailsRoute
  "/_private/settings/storage-locations": typeof PrivateSettingsStorageLocationsRoute
  "/_private/settings/testing-orgs": typeof PrivateSettingsTestingOrgsRoute
  "/_private/inventory/": typeof PrivateInventoryIndexRoute
  "/_private/invitations/": typeof PrivateInvitationsIndexRoute
  "/_private/people/": typeof PrivatePeopleIndexRoute
  "/_private/settings/": typeof PrivateSettingsIndexRoute
  "/_private/species/": typeof PrivateSpeciesIndexRoute
  "/_private/trips/": typeof PrivateTripsIndexRoute
  "/_private/trips/$id/edit": typeof PrivateTripsIdEditRoute
  "/_private/species/$id/": typeof PrivateSpeciesIdIndexRoute
  "/_private/trips/$id/": typeof PrivateTripsIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | ""
    | "/inventory"
    | "/invitations"
    | "/no-access"
    | "/people"
    | "/settings"
    | "/species"
    | "/trips"
    | "/auth/confirm-signup"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/reset-password-confirm"
    | "/auth/reset-password-request"
    | "/auth/set-password"
    | "/invitations/accept"
    | "/inventory/send-for-testing"
    | "/invitations/new"
    | "/settings/containers"
    | "/settings/organisation-details"
    | "/settings/storage-locations"
    | "/settings/testing-orgs"
    | "/inventory/"
    | "/invitations/"
    | "/people/"
    | "/settings/"
    | "/species/"
    | "/trips/"
    | "/trips/$id/edit"
    | "/species/$id"
    | "/trips/$id"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | ""
    | "/no-access"
    | "/auth/confirm-signup"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/reset-password-confirm"
    | "/auth/reset-password-request"
    | "/auth/set-password"
    | "/invitations/accept"
    | "/inventory/send-for-testing"
    | "/invitations/new"
    | "/settings/containers"
    | "/settings/organisation-details"
    | "/settings/storage-locations"
    | "/settings/testing-orgs"
    | "/inventory"
    | "/invitations"
    | "/people"
    | "/settings"
    | "/species"
    | "/trips"
    | "/trips/$id/edit"
    | "/species/$id"
    | "/trips/$id"
  id:
    | "__root__"
    | "/"
    | "/_private"
    | "/_private/inventory"
    | "/_private/invitations"
    | "/_private/no-access"
    | "/_private/people"
    | "/_private/settings"
    | "/_private/species"
    | "/_private/trips"
    | "/auth/confirm-signup"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/reset-password-confirm"
    | "/auth/reset-password-request"
    | "/auth/set-password"
    | "/invitations/accept"
    | "/_private/inventory/send-for-testing"
    | "/_private/invitations/new"
    | "/_private/settings/containers"
    | "/_private/settings/organisation-details"
    | "/_private/settings/storage-locations"
    | "/_private/settings/testing-orgs"
    | "/_private/inventory/"
    | "/_private/invitations/"
    | "/_private/people/"
    | "/_private/settings/"
    | "/_private/species/"
    | "/_private/trips/"
    | "/_private/trips/$id/edit"
    | "/_private/species/$id/"
    | "/_private/trips/$id/"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  AuthConfirmSignupRoute: typeof AuthConfirmSignupRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthResetPasswordConfirmRoute: typeof AuthResetPasswordConfirmRoute
  AuthResetPasswordRequestRoute: typeof AuthResetPasswordRequestRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  AuthConfirmSignupRoute: AuthConfirmSignupRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthResetPasswordConfirmRoute: AuthResetPasswordConfirmRoute,
  AuthResetPasswordRequestRoute: AuthResetPasswordRequestRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_private",
        "/auth/confirm-signup",
        "/auth/login",
        "/auth/reset-password",
        "/auth/reset-password-confirm",
        "/auth/reset-password-request",
        "/auth/set-password",
        "/invitations/accept"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_private": {
      "filePath": "_private.tsx",
      "children": [
        "/_private/inventory",
        "/_private/invitations",
        "/_private/no-access",
        "/_private/people",
        "/_private/settings",
        "/_private/species",
        "/_private/trips"
      ]
    },
    "/_private/inventory": {
      "filePath": "_private/inventory.tsx",
      "parent": "/_private",
      "children": [
        "/_private/inventory/send-for-testing",
        "/_private/inventory/"
      ]
    },
    "/_private/invitations": {
      "filePath": "_private/invitations.tsx",
      "parent": "/_private",
      "children": [
        "/_private/invitations/new",
        "/_private/invitations/"
      ]
    },
    "/_private/no-access": {
      "filePath": "_private/no-access.tsx",
      "parent": "/_private"
    },
    "/_private/people": {
      "filePath": "_private/people.tsx",
      "parent": "/_private",
      "children": [
        "/_private/people/"
      ]
    },
    "/_private/settings": {
      "filePath": "_private/settings.tsx",
      "parent": "/_private",
      "children": [
        "/_private/settings/containers",
        "/_private/settings/organisation-details",
        "/_private/settings/storage-locations",
        "/_private/settings/testing-orgs",
        "/_private/settings/"
      ]
    },
    "/_private/species": {
      "filePath": "_private/species.tsx",
      "parent": "/_private",
      "children": [
        "/_private/species/",
        "/_private/species/$id/"
      ]
    },
    "/_private/trips": {
      "filePath": "_private/trips.tsx",
      "parent": "/_private",
      "children": [
        "/_private/trips/",
        "/_private/trips/$id/edit",
        "/_private/trips/$id/"
      ]
    },
    "/auth/confirm-signup": {
      "filePath": "auth/confirm-signup.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx"
    },
    "/auth/reset-password-confirm": {
      "filePath": "auth/reset-password-confirm.tsx"
    },
    "/auth/reset-password-request": {
      "filePath": "auth/reset-password-request.tsx"
    },
    "/auth/set-password": {
      "filePath": "auth/set-password.tsx"
    },
    "/invitations/accept": {
      "filePath": "invitations.accept.tsx"
    },
    "/_private/inventory/send-for-testing": {
      "filePath": "_private/inventory/send-for-testing.tsx",
      "parent": "/_private/inventory"
    },
    "/_private/invitations/new": {
      "filePath": "_private/invitations/new.tsx",
      "parent": "/_private/invitations"
    },
    "/_private/settings/containers": {
      "filePath": "_private/settings/containers.tsx",
      "parent": "/_private/settings"
    },
    "/_private/settings/organisation-details": {
      "filePath": "_private/settings/organisation-details.tsx",
      "parent": "/_private/settings"
    },
    "/_private/settings/storage-locations": {
      "filePath": "_private/settings/storage-locations.tsx",
      "parent": "/_private/settings"
    },
    "/_private/settings/testing-orgs": {
      "filePath": "_private/settings/testing-orgs.tsx",
      "parent": "/_private/settings"
    },
    "/_private/inventory/": {
      "filePath": "_private/inventory/index.tsx",
      "parent": "/_private/inventory"
    },
    "/_private/invitations/": {
      "filePath": "_private/invitations/index.tsx",
      "parent": "/_private/invitations"
    },
    "/_private/people/": {
      "filePath": "_private/people/index.tsx",
      "parent": "/_private/people"
    },
    "/_private/settings/": {
      "filePath": "_private/settings/index.tsx",
      "parent": "/_private/settings"
    },
    "/_private/species/": {
      "filePath": "_private/species/index.tsx",
      "parent": "/_private/species"
    },
    "/_private/trips/": {
      "filePath": "_private/trips/index.tsx",
      "parent": "/_private/trips"
    },
    "/_private/trips/$id/edit": {
      "filePath": "_private/trips/$id/edit.tsx",
      "parent": "/_private/trips"
    },
    "/_private/species/$id/": {
      "filePath": "_private/species/$id/index.tsx",
      "parent": "/_private/species"
    },
    "/_private/trips/$id/": {
      "filePath": "_private/trips/$id/index.tsx",
      "parent": "/_private/trips"
    }
  }
}
ROUTE_MANIFEST_END */
